import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalService } from '../global/global.service';

@Injectable()
export class UserLoadCheckGuardService {
    get user(): any {
        return this.globalService.user;
    }

    constructor(
        private router: Router,
        private globalService: GlobalService,
    ) {}

    public canActivate(): boolean {
        if (this.user) return true;

        this.router.navigate(['/login']);

        return false;
    }
}
